<div
  class="sidebar"
  #sidebarMenu
  [ngClass]="minimizeSidebarElement ? 'minimize' : ''"
  (mouseenter)="onMouseEnter($event.target)"
  (mouseleave)="onMouseOut($event.target)"
>
  <div class="sidebar-container" fxFill fxLayout="column">
    <!-- HEADER LOGO -->
    <div class="header-container">
      <a
        class="header_logo header-logo-shrink"
        [routerLink]="['/', getBaseURLPath, 'dashboard']"
      ></a>
    </div>

    <div
      class="sidebar-menu-items"
      fxLayout="column"
      fxFlex
      fxLayoutAlign="space-between"
    >
      <div class="top-section">
        <ng-container *ngFor="let menu of filteredMenu">
          <ng-container *ngIf="menu.children?.length; else menuLink">
            <button
              type="button"
              class="sidebar-menu-item sidebar-menu-group"
              [ngClass]="[
                menu.icon || '',
                isMenuExpanded(menu) ? 'expanded' : '',
                isMenuRouteActive(menu) ? 'group-active' : ''
              ]"
              [attr.aria-expanded]="isMenuExpanded(menu)"
              (click)="toggleMenu(menu)"
            >
              <span class="text">{{ menu.title }}</span>
            </button>

            <div
              class="sidebar-submenu"
              [class.expanded]="isMenuExpanded(menu)"
              [attr.aria-hidden]="!isMenuExpanded(menu)"
            >
              <a
                *ngFor="let child of menu.children"
                class="sidebar-submenu-item"
                [routerLink]="getRouterLink(child.link)"
                [routerLinkActive]="'active'"
                [attr.tabindex]="isMenuExpanded(menu) ? null : -1"
              >
                {{ child.title }}
              </a>
            </div>
          </ng-container>

          <ng-template #menuLink>
            <div
              class="sidebar-menu-item"
              [ngClass]="userIsAdmin ? menu.link : menu.icon"
              [routerLink]="getRouterLink(menu.link)"
              [routerLinkActive]="'active'"
            >
              <div class="text">
                {{ menu.title }}
              </div>
            </div>
          </ng-template>
        </ng-container>
      </div>

      <div class="bottom">
        <div class="view-state pointer" (click)="toggleSidebar()">
          {{ isMinimized ? 'Keep maximized' : 'Allow minimize' }}
        </div>

        <div class="sidebar-menu-item signout" (click)="logout()">
          <div class="text">Sign out</div>
        </div>
      </div>
    </div>
  </div>
</div>
